export default __webpack_public_path__ + "static/media/Cori.df96c420.png";